export default __webpack_public_path__ + "static/media/AmmoliteIcon.df691b3f.png";